<template>
  <v-select
    v-if="!isLoading"
    :items="items"
    v-model="model"
    label="Product Type"
    item-text="name"
    item-value="id"
    :disabled="disabled"
    :rules="rules"
  ></v-select>
</template>

<script>
export default {
  data() {
    return {
      model: this.value,
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      items: []
    };
  },
  props: ["value", "disabled", "shopId", "rules"],
  watch: {
    model() {
      this.$emit("input", this.model);
    }
  },
  mounted: function() {
    this.getFittingType();
  },
  methods: {
    getFittingType() {
      this.$store
        .dispatch("products/getProductTypes", {
          shopId: this.shopId
        })
        .then(data => {
          this.items = data.types;
        });
    }
  }
};
</script>
